import { render, staticRenderFns } from "./ChangelogPublic.vue?vue&type=template&id=46c7a1cb&"
import script from "./ChangelogPublic.vue?vue&type=script&lang=js&"
export * from "./ChangelogPublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports